import { loadTheme as loadFabricTheme } from 'office-ui-fabric-react'
import {
  BaseSlots,
  ThemeGenerator,
  themeRulesStandardCreator,
} from 'office-ui-fabric-react/lib/ThemeGenerator'
import { Theme } from './Theme'

const themeRules = themeRulesStandardCreator()

export function loadTheme({
  themeColor,
  textColor,
  backgroundColor,
}: {
  themeColor: string
  textColor: string
  backgroundColor?: string
}): Theme {
  ThemeGenerator.setSlot(
    themeRules[BaseSlots[BaseSlots.primaryColor]],
    themeColor,
    false,
    // !Color(self.themeColor).isDark(),
    true,
    true
  )
  ThemeGenerator.setSlot(
    themeRules[BaseSlots[BaseSlots.foregroundColor]],
    textColor,
    false,
    // !Color(self.themeColor).isDark(),
    true,
    true
  )
  ThemeGenerator.setSlot(
    themeRules[BaseSlots[BaseSlots.backgroundColor]],
    backgroundColor || '#ffffff',
    false,
    // !Color(self.themeColor).isDark(),
    true,
    true
  )

  const palette = ThemeGenerator.getThemeAsJson(themeRules)

  const theme = {
    ...loadFabricTheme({ palette }),
    breakpoints: [32, 48, 64],
    space: [0, 6, 12, 18, 24],
  }

  // tslint:disable-next-line:no-console
  return theme
}

// export const loadTheme = (fabricOverrides: Partial<ITheme> = {}): Theme => ({
//   ...loadFabricTheme(fabricOverrides),
// })

// import { loadTheme as loadFabricTheme } from 'office-ui-fabric-react'
// import { Theme } from './Theme'

// export const loadTheme = () => {
//   const palette = {
//     themePrimary: '#d5001c',
//     themeLighterAlt: '#fdf3f5',
//     themeLighter: '#f8d1d6',
//     themeLight: '#f3aab4',
//     themeTertiary: '#e75c6f',
//     themeSecondary: '#db1a34',
//     themeDarkAlt: '#c1001a',
//     themeDark: '#a30016',
//     themeDarker: '#780010',
//     neutralLighterAlt: '#f8f8f8',
//     neutralLighter: '#f4f4f4',
//     neutralLight: '#eaeaea',
//     neutralQuaternaryAlt: '#dadada',
//     neutralQuaternary: '#d0d0d0',
//     neutralTertiaryAlt: '#c8c8c8',
//     neutralTertiary: '#bbc0c3',
//     neutralSecondary: '#7c8388',
//     neutralPrimaryAlt: '#464c50',
//     neutralPrimary: '#313639',
//     neutralDark: '#25282b',
//     black: '#1b1e1f',
//     white: '#ffffff',
//   }

//   return {
//     ...loadFabricTheme({ palette }),
//     breakpoints: [32, 48, 64],
//     space: [0, 6, 12, 18, 24],
//   } as Theme
// }
